import PostSchedule from '@/models/PostSchedule';

export const postScheduleMixin = {
  data() {
    return {
      postScheduleIds: [],
      postScheduleMapping: {}
    };
  },

  methods: {
    getPostSchedule(postId, sectionId) {
      const postScheduleId = this.postScheduleMapping[`${postId}_${sectionId}`];

      return PostSchedule.find(postScheduleId);
    },

    recordPostSchedule(data) {
      const postScheduleIds = data.map(({ id, post, section } = {}) => {
        this.$set(this.postScheduleMapping, `${post.id}_${section}`, id);

        return id;
      });

      if (postScheduleIds.length) {
        this.postScheduleIds = [...this.postScheduleIds, ...postScheduleIds];
      }
    }
  }
};
